<template>
    <div class="mt-2">
        <div>
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">fa-briefcase</v-icon>
                    Emergency Contacts
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <ViewPersonEmergencyContactDialog />
                <EditPersonEmergencyContactDialog />
                <AddPersonEmergencyContactDialog :person-id="personId" />
            </v-toolbar>
            <v-data-table
                :headers="personEmergencyContactTableHeaders"
                :items="personEmergencyContactList"
                class="elevation-1"
                v-if="person !== undefined"
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <tr>
                        <td class="text-xs-left">{{ props.item.name }}</td>
                        <td class="text-xs-left">{{ props.item.relationship }}</td>
                        <td class="text-xs-left">{{ props.item.mobilePhone }}</td>
                        <td class="text-xs-left">{{ props.item.telephone }}</td>
                        <td class="text-xs-left">{{ props.item.emailAddress }}</td>
                        <td class="text-xs-left">{{ props.item.addressLineOne }}...</td>

                        <td class="text-xs-left">{{ props.item.comments }}</td>
                        <td class="justify-center layout px-0">
                            <v-icon
                                @click="viewItem(props.item)"
                                class="mr-2"
                                small
                                style="display: inline-flex;"
                            >
                                remove_red_eye
                            </v-icon>
                            <v-icon
                                @click="editItem(props.item)"
                                class="mr-2"
                                small
                                style="display: inline-flex;"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                @click="deleteItem(props.item)"
                                small
                                style="display: inline-flex;"
                            >
                                delete
                            </v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import {DELETE_PERSON_EMERGENCY_CONTACT, FETCH_PERSON_EMERGENCY_CONTACT_LIST,} from "@/store/person_emergency_contact/actions.js";
    import EditTableFunctions from '../editTableFunctions';
    import {LOAD_PERSON_EMERGENCY_CONTACT_TO_EDIT, LOAD_PERSON_EMERGENCY_CONTACT_TO_VIEW, TOGGLE_EDIT_PERSON_EMERGENCY_CONTACT_DIALOG, TOGGLE_VIEW_PERSON_EMERGENCY_CONTACT_DIALOG} from "@/store/person_emergency_contact/mutations.js";

    import ViewPersonEmergencyContactDialog from "./ViewPersonEmergencyContactDialog";
    import AddPersonEmergencyContactDialog from "./AddPersonEmergencyContactDialog";
    import EditPersonEmergencyContactDialog from "./EditPersonEmergencyContactDialog";

    export default {
        // TODO:: Trial periods

        name: "PersonEmergencyContactsTable",
        components: {ViewPersonEmergencyContactDialog, AddPersonEmergencyContactDialog, EditPersonEmergencyContactDialog},

        mixins: [
            EditTableFunctions,
        ],

        props: {
            personId: {
                type: Number,
                required: true,
            }
        },

        data() {
            return {
                idName: 'personEmergencyContactId',
                dialog: false,
                personEmergencyContactTableHeaders: [
                    {text: 'Name', value: 'name'},
                    {text: 'Relationship', value: 'relationship'},
                    {text: 'Mobile', value: 'mobile'},
                    {text: 'Telephone ', value: 'telephone'},
                    {text: 'Email', value: 'emailAddress'},
                    {text: 'Address', value: 'addressLineOne'},
                    {text: 'Comments', value: 'comments'},
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                rowsPerPageItems: [10, 20, 50, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],
                pagination: {
                    rowsPerPage: 10
                },
                editedId: -1,
            }
        },

        computed: {
            // emergencyContactTypeList()
            // {
            //     return this.$store.getters.emergencyContactTypeList;
            // },
            // jobList() {
            //     return this.$store.getters.jobList;
            // },
            // editJobId: {
            //     get()
            //     {
            //         return this.$store.state.personEmergencyContact.editPersonEmergencyContact.jobId;
            //     },
            //     set(value)
            //     {
            //         this.updateValue('jobId', value);
            //     },
            // },
            editEmergencyContactTypeId: {
                get() {
                    return this.$store.state.personEmergencyContact.editPersonEmergencyContact.emergencyContactTypeId;
                },
                set(value) {
                    this.updateValue('emergencyContactTypeId', value);
                },
            },
            editWeeklyHours: {
                get() {
                    return this.$store.state.personEmergencyContact.editPersonEmergencyContact.weeklyHours;
                },
                set(value) {
                    this.updateValue('weeklyHours', value);
                },
            },
            editStartDate: {
                get() {
                    return this.$store.state.personEmergencyContact.editPersonEmergencyContact.startDate;
                },
                set(value) {
                    this.updateValue('startDate', value);
                },
            },
            editEndDate: {
                get() {
                    return this.$store.state.personEmergencyContact.editPersonEmergencyContact.endDate;
                },
                set(value) {
                    this.updateValue('endDate', value);
                },
            },
            editComments: {
                get() {
                    return this.$store.state.personEmergencyContact.editPersonEmergencyContact.comments;
                },
                set(value) {
                    this.updateValue('comments', value);
                },
            },
            ...mapGetters(
            [
                "person",
                "personEmergencyContactList",
                // "emergencyContactTypeList",
            ]
            )
        },

        mounted() {
            if (this.personId) {
//                console.log(this.personId);
                // this.fetchAllTableItems();
            }
        },

        methods: {
            ...mapActions({
                fetchTableList: FETCH_PERSON_EMERGENCY_CONTACT_LIST,
                deleteTableItem: DELETE_PERSON_EMERGENCY_CONTACT,
            }),

            ...mapMutations({
                loadTableItemToEdit: LOAD_PERSON_EMERGENCY_CONTACT_TO_EDIT,
                loadTableItemToView: LOAD_PERSON_EMERGENCY_CONTACT_TO_VIEW,
                toggleEditDialog: TOGGLE_EDIT_PERSON_EMERGENCY_CONTACT_DIALOG,
                toggleViewDialog: TOGGLE_VIEW_PERSON_EMERGENCY_CONTACT_DIALOG,
            })
        },
    }
</script>

<style scoped>
</style>
